const tenantData = {
    getTenantList() {
        const raw = localStorage.getItem('USER_TENANTS');
        let res = [];
        if (raw) {
            try {
                const parsed = JSON.parse(raw);
                if (Array.isArray(parsed)) res = parsed;
            } catch (e) {
                console.error('租户信息异常，请联系管理员');
            }
        }
        return res
    },

    getEquCode(){
      const equCode = localStorage.getItem('SHOW_TENANT');
      if (equCode) {
        try {
          return JSON.parse(equCode);
        } catch (e) {
          console.error('设备码信息异常，请联系管理员');
        }
      }
      return null
    },

    getTenantModel(){
      return localStorage.getItem('TENANT_MODEL');
    },

    setTenantModel(model){
      localStorage.setItem('TENANT_MODEL', model);
    },

    getRoleName(){
      const user = JSON.parse(localStorage.getItem('user'))
      return user?.roleName || "";
    }
}

export { tenantData }
